import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, Search, ShieldCheck } from "lucide-react";
import { useStaff } from "@/lib/staff";

export function StaffTopBar({ onMenu }) {
  const { me } = useStaff();
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/staff/students?q=${encodeURIComponent(q.trim())}`);
  };
  return (
    <header className="h-14 shrink-0 flex items-center gap-3 px-3 sm:px-6 border-b border-[#1B2740] bg-[#0C1322]/90 backdrop-blur-md" data-testid="staff-role-bar">
      <button onClick={onMenu} className="lg:hidden h-9 w-9 rounded-lg flex items-center justify-center text-neutral-300 hover:bg-white/[0.05]" aria-label="Open staff menu" data-testid="staff-menu-btn">
        <Menu className="h-5 w-5" />
      </button>
      <span className="inline-flex items-center gap-1.5 rounded-full border border-sky-400/30 bg-sky-400/15 px-3 py-1 text-xs font-medium text-sky-100 shrink-0" data-testid="staff-area-badge">
        <ShieldCheck className="h-3.5 w-3.5" />Staff area
      </span>
      <span className="hidden sm:inline text-xs text-neutral-400 shrink-0">Signed in as <b className="font-medium text-neutral-100" data-testid="staff-current-role">{me.role_name}</b></span>
      <form onSubmit={submit} className="ml-auto flex-1 max-w-sm relative" role="search">
        <Search className="h-4 w-4 text-neutral-500 absolute left-3 top-1/2 -translate-y-1/2" aria-hidden="true" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Find a student by name or email" aria-label="Find a student"
          className="w-full h-9 rounded-full border border-[#22304B] bg-[#0B1220] pl-9 pr-3 text-sm text-neutral-100 placeholder:text-neutral-500 outline-none focus:border-sky-400/70"
          data-testid="staff-search-input" />
      </form>
      <span className="hidden md:inline text-xs text-neutral-500 truncate max-w-[220px]" data-testid="staff-current-email">{me.email}</span>
    </header>
  );
}
